import { queryOptions } from "@tanstack/react-query";
import { productionApi } from "./api.ts";

// Ключи производства начинаются с "production": после отметки или выпуска
// доска, заказ и карточка изделия сбрасываются разом.
export const PRODUCTION = ["production"] as const;

export const boardQuery = queryOptions({
  queryKey: [...PRODUCTION, "board"],
  queryFn: () => productionApi.board(),
  // Доска висит на мониторе у линии: сама обновляется раз в минуту, как в chmk_floor.
  refetchInterval: 60_000,
});

export const moQuery = (id: string) =>
  queryOptions({ queryKey: [...PRODUCTION, "order", id], queryFn: () => productionApi.order(id), retry: false });

export const cardQuery = (serial: string) =>
  queryOptions({ queryKey: [...PRODUCTION, "card", serial], queryFn: () => productionApi.card(serial), retry: false });

export const activeQuery = queryOptions({ queryKey: [...PRODUCTION, "active"], queryFn: productionApi.myActive });

